export const sampleImage =
  // "https://images.unsplash.com/photo-1487958449943-2429e8be8625?q=80&w=900&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  "https://cdn.filestackcontent.com/PKIcKga_QLKv1rkAdPQB/content=t:attachment,f:%22photo-1487958449943-2429e8be8625.avif%22/fA4GiTQQSsKHKR8Kcwim"
export const sampleHtml =
  "<p>The art or practice of designing and constructing buildings.</p>"

// term === front of card, definition === back of card
export const createSampleFlashcard = (num = 1) => ({
  order: num,
  definition: {
    image: num !== 1 ? sampleImage : "",
    html: num === 1 ? sampleHtml : ""
  },
  term: {
    image: "",
    html: `<p>Front of card ${num}</p>`
  }
})

export default {
  type: "Flashcards",
  icon: "cards",
  helpLink:
    "https://help.pathwright.com/create-a-course/adding-content-with-blocks/flashcards-block-new",
  menu: {
    category: "interactive",
    order: 2
  },
  layouts: {
    flashcards: {
      key: "flashcards",
      label: "Flashcards",
      data: {
        flashcards: [createSampleFlashcard(1), createSampleFlashcard(2)]
      }
    }
  },
  schema: `
    enum LegacyFlashcardType {
      HTML
      IMAGE
    }

    type FlashcardMedia {
      html: String
      image: String @media
      altText: String
      showHTML: Boolean
      showImage: Boolean
      audio: String @media
      type: LegacyFlashcardType
    }

    type Flashcard {
      order: Int!
      term: FlashcardMedia!
      definition: FlashcardMedia!
    }

    type Flashcards implements Block {
      id: ID!
      flashcards: [Flashcard]!
    }
  `
}
